import { render, staticRenderFns } from "./callForBidDetailList.vue?vue&type=template&id=9f347336&scoped=true"
import script from "./callForBidDetailList.vue?vue&type=script&lang=js"
export * from "./callForBidDetailList.vue?vue&type=script&lang=js"
import style0 from "./callForBidDetailList.vue?vue&type=style&index=0&id=9f347336&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f347336",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9f347336')) {
      api.createRecord('9f347336', component.options)
    } else {
      api.reload('9f347336', component.options)
    }
    module.hot.accept("./callForBidDetailList.vue?vue&type=template&id=9f347336&scoped=true", function () {
      api.rerender('9f347336', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/page/callForBidDetailList.vue"
export default component.exports